import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.updateColspans();
    window.addEventListener('resize', this.updateColspans);
  }

  updateColspans() {
    const isSmallScreen = window.innerWidth < 768;

    document.querySelectorAll('table td, table th').forEach((cell) => {
      if (isSmallScreen) {
        if (cell.hasAttribute('colspan')) {
          cell.dataset.colspan = cell.getAttribute('colspan');
          cell.removeAttribute('colspan');
        }
      } else {
        if (cell.dataset.colspan) {
          cell.setAttribute('colspan', cell.dataset.colspan);
        }
      }
    });
  }
}
